/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * Enough to render a list and decide what to open. The payload is fetched one artifact at a
 * time from whichever drill-in route the caller has —
 * `/learn/sessions/{sessionId}/artifacts/{artifactId}` for a facilitator,
 * `/learn/me/{token}/artifacts/{artifactId}` for a take-home reader.
 * 
 * @export
 * @interface LearnArtifactSummary
 */
export interface LearnArtifactSummary {
    /**
     * 
     */
    id: string;
    /**
     * Which visit produced it. Load-bearing on the facilitator listing, where it is how a row
     * is attributed to a team against `GET /learn/sessions/{sessionId}/visits`; redundant on
     * `/learn/visits/me`, where every row belongs to the caller, but kept for one shape.
     * 
     * **Not present on the take-home page**, which uses `TakeHomeArtifactSummary` — see there
     * for why that page must not carry the Visit UUID.
     * 
     */
    visitId: string;
    /**
     * 
     */
    kind: string;
    /**
     * 
     */
    title: string;
    /**
     * 
     */
    activityKey?: string | null;
    /**
     * 
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the LearnArtifactSummary interface.
 */
export function instanceOfLearnArtifactSummary(value: object): value is LearnArtifactSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('visitId' in (value as Record<string, any>)) && !('visit_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['visitId'] === undefined && (value as Record<string, any>)['visit_id'] === undefined)) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    return true;
}

export function LearnArtifactSummaryFromJSON(json: any): LearnArtifactSummary {
    return LearnArtifactSummaryFromJSONTyped(json, false);
}

export function LearnArtifactSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LearnArtifactSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'visitId': json['visit_id'],
        'kind': json['kind'],
        'title': json['title'],
        'activityKey': json['activity_key'] === undefined ? undefined : json['activity_key'] === null ? null : json['activity_key'],
        'createdAt': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
    };
}

export function LearnArtifactSummaryToJSON(json: any): LearnArtifactSummary {
    return LearnArtifactSummaryToJSONTyped(json, false);
}

export function LearnArtifactSummaryToJSONTyped(value?: LearnArtifactSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'visit_id': value['visitId'],
        'kind': value['kind'],
        'title': value['title'],
        'activity_key': value['activityKey'],
        'created_at': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
    };
}

